export enum ChartType {
  BarChart = 'BarChart',
  ColumnChart = 'ColumnChart',
  LineChart = 'LineChart'
}

const chartPackages: Record<ChartType, string> = {
  [ChartType.BarChart]: 'corechart',
  [ChartType.ColumnChart]: 'corechart',
  [ChartType.LineChart]: 'corechart'
};

export function getPackageForChartType(type: ChartType): string {
  return chartPackages[type] ?? 'corechart';
}

export interface ChartReadyEvent {
  chart: google.visualization.ChartBase;
}

export interface ChartErrorEvent {
  id: string;
  message: string;
  detailedMessage: string;
  options: Record<string, unknown>;
}
